import SwishLogo from '@/assets/swish.png?w=24&h=24&format=webp&imagetools';
import { PaymentProvider } from '@/hooks/invoice/types';
import { AccountBalance, CreditCard } from '@mui/icons-material';
import Stack from '@mui/material/Stack';

export const PaymentIcon = ({
  provider,
  size = 'medium',
  alt
}: {
  provider: PaymentProvider;
  size?: 'small' | 'medium';
  alt: string;
}) => {
  switch (provider?.toLowerCase()) {
    case 'swish':
      return (
        <Stack
          component='img'
          src={SwishLogo}
          alt={alt}
          sx={{
            width: size === 'medium' ? '24px' : '16px',
            height: size === 'medium' ? '24px' : '16px'
          }}
        />
      );
    case 'inveroak':
      return <CreditCard fontSize={size} />;
    case 'banktransfer':
      return <AccountBalance fontSize={size} />;
    default:
      return <CreditCard fontSize={size} />;
  }
};
